import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import UnsoldQueue from './UnsoldQueue';
import CompletedJobs from './CompletedJobs';
import OpenBalances from './OpenBalances';
import useBreakpoints from '../../utilities/useBreakpoints'

const FollowUpView = () => {

    const { isBreakpoint } = useBreakpoints();

    return (
        <Col>
            {isBreakpoint('sm') &&
                <Row>
                    <Col lg>
                        <Row className="justify-content-center">
                            <UnsoldQueue />
                        </Row>
                    </Col>
                    <Col lg>
                        <Row className="justify-content-center">
                            <CompletedJobs />
                        </Row>
                    </Col>
                </Row>
            }
            <Row>
                <Col lg='6'>
                    <Row className="justify-content-center">
                        <OpenBalances />
                    </Row>
                </Col>
            </Row>
        </Col>
    );
}

export default FollowUpView;